exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\ninput.ng-invalid {\n\tborder:1px solid #FF9000;\n}\n\nselect.ng-invalid.ng-untouched{\n\tborder:1px solid #FF9000;\n}\n\nselect.ng-invalid.ng-touched{\n\tborder:1px solid red;\n}\n\n.product-field-border{\n\tborder:1px solid #FF9000;\n}\n\nlabel.font-size-17{\n\tfont-size: 17px;\n}\n.lrform_error_message\n{\n\tcolor: red;\n}\n.padding-10{\n\tpadding: 10px !important;\n}\n\ntr {\n    cursor: pointer;\n}\n\nsmall{\n\tfont-size: 14px;\n\ttext-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/l-r-form/l-r-form.component.css
// module id = ../../../../../src/app/l-r-form/l-r-form.component.css
// module chunks = main